var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStringCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12zM6.31 3.5H4.68L1.5 13h1.692l.632-2.036h3.312L7.768 13H9.5L6.31 3.5zM11.966 7c-.424 0-.837.061-1.238.184a3.167 3.167 0 0 0-1.032.52l.548 1.18c.189-.166.419-.297.69-.395.27-.097.546-.146.826-.146.405 0 .708.1.91.298.202.198.304.482.304.85H11.76c-.77 0-1.339.155-1.707.466-.369.31-.553.736-.553 1.278 0 .339.078.642.235.91.156.267.383.476.68.628.297.151.647.227 1.052.227.783 0 1.317-.27 1.604-.812v.725H14.5V9.588c0-.866-.219-1.514-.656-1.944-.437-.43-1.063-.644-1.878-.644zm1.008 3.477v.595c-.085.26-.229.457-.43.59-.203.134-.435.2-.696.2-.267 0-.477-.062-.63-.189a.631.631 0 0 1-.23-.514c0-.455.312-.682.939-.682h1.047zm-7.49-4.82 1.132 3.638H4.354l1.13-3.637z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStringCase);
export default __webpack_public_path__ + "static/media/string-case.c29e3818466d06441ad16432c77bcad1.svg";
export { ForwardRef as ReactComponent };